import fragment from 'graphql/fragments/product/StockValuationCriteriaFragment.graphql';
import { ALLOW_EDIT } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const StockValuationCriteria: EntityType = {
  type: 'StockValuationCriteria',
  title: 'Stock Valuation Report',
  formTitle: 'Stock Valuation Report',
  formUrl: '/Company/StockValuation/Criteria',
  fragment,
  screenReference: 'STOCK_VALUATION',
  operations: ALLOW_EDIT,
};

export default StockValuationCriteria;
